import { AbstractShape } from "../abstract/Shape";
import { ComposedMetrics } from "../clases/ComposedMetrics";
import { TimeUnit } from "../enums/TimeUnit";
import { BoxMetrics } from "../interfaces/BoxMetrix";
import { HeatMap } from "../interfaces/HeatMap";
import { MetricsMeasures } from "../interfaces/MetricType";

export function assignMetrics(mainItems: AbstractShape[], metricsList: BoxMetrics[], composed: ComposedMetrics, isUser: boolean = false){
    for (const item of mainItems) {
        let metrics = metricsList.find((metric)=>item.dbData.properties.__EDT_UUID__===metric.box_uuid);
        if(!metrics && isUser){
            item.setGrayTheme();
            item.setMetrics(undefined, undefined);
            assignMetrics(item.children, metricsList, composed, isUser);
            continue;
        }
        if(!isUser) item.restoreTheme();
        item.setMetrics(metrics, composed);
        assignMetrics(item.children, metricsList, composed);
    }
}

export function assignHeatMap(mainItems: AbstractShape[], heatmapList: HeatMap[]){
    for (const item of mainItems) {
        let heatmap = heatmapList.find((heatmap)=>item.dbData.properties.__EDT_UUID__===heatmap.nodeUUID);
        item.setHeatmap(heatmap);
        assignHeatMap(item.children, heatmapList);
    }
}

export function toggleHeatmapList(mainItems: AbstractShape[], show: boolean){
    for (const item of mainItems) {
        item.toggleHeatmapTheme(show);
        toggleHeatmapList(item.children, show);
    }
}